import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { auctionsAPI } from "../services/api";
import "./Auctions.css";

const statusClass = (status) => `auction-status-badge auction-status-${status || "draft"}`;

const Auctions = () => {
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const res = await auctionsAPI.getAll(
        statusFilter ? { status: statusFilter } : {},
      );
      setAuctions(res.data.data || []);
    } catch {
      toast.error("Failed to load auctions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [statusFilter]);

  const toggleVisibility = async (auction) => {
    try {
      await auctionsAPI.toggleVisibility(auction.id, {
        is_visible_on_app: !auction.is_visible_on_app,
      });
      toast.success("Visibility updated");
      load();
    } catch {
      toast.error("Update failed");
    }
  };

  if (loading) {
    return <div className="loading">Loading auctions…</div>;
  }

  return (
    <div className="users-container">
      <div className="auctions-toolbar">
        <Link to="/auctions/new" className="btn btn-primary">
          + Create auction
        </Link>
        <Link to="/auction-deposits" className="btn btn-secondary">
          All deposits
        </Link>
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="">All statuses</option>
          <option value="draft">Draft</option>
          <option value="scheduled">Scheduled</option>
          <option value="live">Live</option>
          <option value="ended">Ended</option>
        </select>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Status</th>
              <th>Scheduled</th>
              <th>Items</th>
              <th>Visible on app</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {auctions.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center", color: "var(--text-muted)" }}>
                  No auctions yet. Create one to get started.
                </td>
              </tr>
            ) : null}
            {auctions.map((a) => (
              <tr key={a.id} className={`table-row-status table-row-status-${a.status}`}>
                <td>
                  <Link to={`/auctions/${a.id}/edit`}>{a.title}</Link>
                </td>
                <td>
                  <span className={statusClass(a.status)}>{a.status}</span>
                </td>
                <td>{a.scheduled_at ? new Date(a.scheduled_at).toLocaleString() : "—"}</td>
                <td>{a.item_count ?? 0}</td>
                <td>
                  <label className="auction-visibility-toggle">
                    <input
                      type="checkbox"
                      checked={!!a.is_visible_on_app}
                      onChange={() => toggleVisibility(a)}
                    />
                    {a.is_visible_on_app ? "🟢 Showing on app" : "⚫ Hidden from app"}
                  </label>
                </td>
                <td>
                  <div className="auction-actions">
                    <Link to={`/auctions/${a.id}/edit`}>Edit</Link>
                    <Link to={`/auctions/${a.id}/live`}>Live</Link>
                    <Link to={`/auctions/${a.id}/bids`}>Bids</Link>
                    <Link to={`/auctions/${a.id}/results`}>Results</Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Auctions;
